import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { resultsConfigSelector } from 'ctm-selectors';
import { Text, SimpleFlexbox } from 'ctm-components';
import { getMultiLevelSortCriteria } from 'ctm-util-functions/lib/multi_sorting_config';
import { SimpleRadioButtonGroup } from '../../form/simple_radio_button_group/simple_radio_button_group';

class _SidebarFrequencyToggle extends PureComponent {

    /**
   * Handles the on change method
   * @param {Event} event - the on change event
   * @param {string} value - the value to set
   */
    onChange = (event, value) => {
        const { sortResults, sortArrayMultiLevel, setFrequencyFilter } = this.props;
        sortResults(value);
        sortArrayMultiLevel(value);
        setFrequencyFilter(value);
    };

    render = () => {
        return (
            <div>
                <SimpleFlexbox padding="bottom_xsmall">
                    <Text size="large" variant="margin_top_bottom_small"><strong>Payment frequency</strong></Text>
                </SimpleFlexbox>
                <SimpleRadioButtonGroup {...this.props} onChange={this.onChange} />
            </div>
        );
    };

}

_SidebarFrequencyToggle.propTypes = {
    sortResults: PropTypes.func,
    sortArrayMultiLevel: PropTypes.func,
    setFrequencyFilter: PropTypes.func,
    value: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string
        })
    )
};

const mapStateToProps = (state) => {
    return {
        value: resultsConfigSelector(state).getIn(['filters', 'frequency'])
    };
};

const mapDispatchToProps = (dispatch) => ({
    sortResults: (frequency) => {
        dispatch({
            type: 'SORT_RESULTS',
            sortBy: `productMeta.price.${frequency}Premium`,
            sortDir: 'asc',
            sortType: 'numeric'
        });
    },
    sortArrayMultiLevel: (frequency) => {
        dispatch({
            type: 'SORT_ARRAY_MULTI_LEVEL',
            sortCriteria: getMultiLevelSortCriteria(frequency)
        });
    },
    setFrequencyFilter: (frequency) => {
        dispatch({
            type: 'SET_FILTER_VALUE',
            filter: 'frequency',
            filterValue: frequency
        });
    }
});

const SidebarFrequencyToggle = connect(mapStateToProps, mapDispatchToProps)(_SidebarFrequencyToggle);

export { SidebarFrequencyToggle, _SidebarFrequencyToggle };
